<template>
	<div class="jdFinance" :style="{ height: window_banner_ab == 'c' ? '1rem' : '1.39rem' }">
		<!-- <div class="box" v-if="jd_finance_rule_window">
			<img class="jd-finance-title" src="../../assets/images/welfare/jd-finance-title3.png" alt="" v-if="jd_finance_window_text == 1" />
			<img class="jd-finance-title" src="../../assets/images/welfare/jd-finance-title4.png" alt="" v-if="jd_finance_window_text == 2" />

			<div class="jd-finance-describe" v-if="jd_finance_window_text == 1">
				<P class="jd-finance-describe-top"
					>新人下载最高立得<span class="jd-finance-describe-number">5</span><span class="jd-finance-describe-word">元</span>现金</P
				>
				<P class="jd-finance-describe-bottom"
					>更有<span class="jd-finance-describe-number">888</span><span class="jd-finance-describe-word">元</span>大礼包</P
				>
			</div>
			<div class="jd-finance-describe" v-if="jd_finance_window_text == 2">
				<P class="jd-finance-describe-top"
					>试试京东白条,最高可借<span class="jd-finance-describe-number">20</span><span class="jd-finance-describe-word">万</span>!</P
				>
				<P class="jd-finance-describe-bottom"
					>新用户更领<span class="jd-finance-describe-number">888</span><span class="jd-finance-describe-word">元</span>大礼包</P
				>
			</div>

			<button class="immediately-receive" @click.stop.prevent="promptDraw()">
				<span class="immediately-receive-word">点击立即领取</span>
			</button>
			<p class="reminder-word">(本活动仅限京东金融App新用户参与)</p>
			<div class="dialog-close-icon" @click="closePop()"></div>
		</div> -->
		<div class="box" v-if="window_banner_ab == 'c'">
			<div class="fission-title"><span>快音送你现金红包</span></div>
			<div class="jd-finance-describe fission-title-describe">
				<P>领现金，秒提现</P>
			</div>

			<button class="immediately-receive" @click.stop.prevent="skipToFissionPage()">
				<span class="immediately-receive-word">立即领取</span>
			</button>
			<div class="dialog-close-icon dialog-close-icon-fission" @click="closePop()"></div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		name: 'JdFinanceBottom-Popup',
		computed: {
			...mapGetters('withdraw/jdFinance', ['jd_finance_window_text', 'window_banner_ab', 'jd_finance_rule_window']),
		},
		methods: {
			closePop() {
				this.$emit('closePopup');
			},
			skipToFissionPage() {
				this.closePop();
				// 跳转去裂变页
				window.location.href = '/invite_friend';
			},
		},
	};
</script>

<style lang="less" scoped>
	.jdFinance {
		width: 2.68rem;
		box-sizing: border-box;
		padding: 0.03rem;
		border-radius: 0.12rem;
		background-image: -webkit-linear-gradient(left, #ff1239 0%, #9e55f9 60%, #ff0016 90%);

		.box {
			width: 100%;
			height: 100%;
			border-radius: 0.12rem;
			background: #fff;
			display: flex;
			align-items: center;
			flex-direction: column;
			position: relative;
			.jd-finance-title {
				width: 1.79rem;
				height: 0.28rem;
				margin-top: 0.1rem;
			}

			.fission-title {
				width: 1.79rem;
				height: 0.4rem;
				text-align: center;
				background-size: 1.79rem 0.28rem;
				background-image: url('../../../src/assets/images/welfare/jd-finance-title5.png') !important;
				background-position: 50% 50%;
				background-repeat: no-repeat;
				span {
					width: 1.19rem;
					height: 0.18rem;
					font-size: 0.17rem;
					font-family: PingFang-SC-Heavy, PingFang-SC;
					font-weight: 800;
					color: #ff0000;
					line-height: 0.4rem;
				}
				&-describe {
					height: 0.2rem !important;
				}
			}
			.jd-finance-describe {
				width: 1.95rem;
				height: 0.42rem;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				font-size: 0.13rem;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				line-height: 0.21rem;

				p {
					margin: 0.01rem auto;
				}
				&-number {
					height: 0.2rem;
					font-size: 0.2rem;
					font-family: DINAlternate-Bold, DINAlternate;
					font-weight: bold;
					color: #ff0000;
					line-height: 0.2rem;
					margin-left: 0.05rem;
					margin-right: 0.02rem;
					margin-top: 0.01rem;
					display: inline-block;
					vertical-align: text-bottom;
				}
				&-word {
					height: 0.13rem;
					font-size: 0.13rem;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #ff0000;
					line-height: 0.13rem;
					margin-right: 0.02rem;
					display: inline-block;
				}
			}
			.immediately-receive {
				width: 1.83rem;
				height: 0.22rem;
				line-height: 0.22rem;
				background: #ff2b3d;
				border-radius: 0.25rem;
				margin: 0.05rem 0 0.15rem 0;
				&-word {
					height: 0.12rem;
					font-size: 0.12rem;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #ffffff;
					line-height: 0.12rem;
				}
			}
			.reminder-word {
				height: 0.1rem;
				font-size: 0.1rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #bbbbbb;
				line-height: 0.1rem;
			}
			.dialog-close-icon {
				position: absolute;
				z-index: 2034;
				top: 1.64rem;
				left: 50%;
				margin-left: -0.2rem;
				width: 0.4rem;
				height: 0.4rem;
				background-size: 0.4rem 0.4rem;
				background-image: url('../../../src/assets/images/welfare/dialog-close-icon.png') !important;
				background-position: 85% 25%;
				background-repeat: no-repeat;
				&-fission {
					top: 1.24rem !important;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/JdFinanceBottomPopup.vue